import { useEffect } from "react";
import { AmityUiKitSocial } from "@amityco/ui-kit-open-source";
import MenuService from "../../components/Menu/menuService";

export const Community = () => {
  const { selectPage } = MenuService();

  useEffect(() => {
    selectPage("menu-community");
  }, []);

  return <AmityUiKitSocial />;
};

export default Community;
